var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-metric-button",attrs:{"data-testid":"add-metric-button"}},[_c('Button',{attrs:{"text":"","iconLeft":"mdi-plus","data-testid":"add-metric-btn"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Add Metric ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }